import { render, staticRenderFns } from "./informationRangeSetting.vue?vue&type=template&id=dbd8954e&scoped=true"
import script from "./informationRangeSetting.vue?vue&type=script&lang=js"
export * from "./informationRangeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd8954e",
  null
  
)

export default component.exports